// VSNcareertracker.js
import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import './VSNcareertracker.css';
import TrainingVideos from './PlayerExtras/TrainingVideos';
import MyJourney from './PlayerExtras/MyJourney';
import PlayerReporting from './PlayerExtras/PlayerReporting';

const VSNcareertracker = ({ userId }) => {
  return (
    <div className="vsn-tracker">
      <h2>Career Tracker</h2>
      <hr />
      <div className="button-group">
        <NavLink
          to="training-videos"
          className={({ isActive }) =>
            `tracker-btn ${isActive ? 'active' : ''}`
          }
        >
          Training Videos
        </NavLink>
        <NavLink
          to="my-journey"
          className={({ isActive }) =>
            `tracker-btn ${isActive ? 'active' : ''}`
          }
        >
          My Journey
        </NavLink>
        <NavLink
          to="player-reporting"
          className={({ isActive }) =>
            `tracker-btn ${isActive ? 'active' : ''}`
          }
        >
          Player Reporting
        </NavLink>
      </div>

      <div className="tracker-content">
        <Routes>
          <Route path="training-videos" element={<TrainingVideos userId={userId} />} />
          <Route path="my-journey" element={<MyJourney userId={userId} />} />
          <Route path="player-reporting" element={<PlayerReporting userId={userId} />} />
        </Routes>
      </div>
    </div>
  );
};

export default VSNcareertracker;


